import { Typography, useTheme } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { Chip } from '@shared/components';
import { TrashIcon } from '@shared/custom-icons';

interface Props {
  resetFilters: () => void;
}

export const RemoveAllFiltersChip = ({ resetFilters }: Props) => {
  const t = useAppTFunction();
  const theme = useTheme();
  const palette = theme.vars.palette;
  return (
    <Chip
      rounded
      label={
        <Typography color="text.secondary" variant="body2">
          {t('myAssortment.filters.clearFilters')}
        </Typography>
      }
      backgroundColor={palette.grey[50]}
      textColor={palette.text.primary}
      onDelete={resetFilters}
      onClick={resetFilters}
      deleteIcon={<TrashIcon />}
      sx={{ border: '1px solid', borderColor: 'divider' }}
    />
  );
};
